<div *ngIf="subscription" class="ShowSubscription">
  <div class="ShowSubscription-header mb-5">
    <h4 class="title__page">View Subscription</h4>
  </div>
  <div class="ShowSubscription-body">
    <div class="row">
      <div class="col col-md-12">
        <p><b>Team Code: </b>{{ subscription.team_code }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-12">
        <p><b>Plan: </b>{{ subscription.plan_id }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-12">
        <p><b>Plan Cost: </b>{{ subscription.plan_cost }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-12">
        <p><b>Trial days: </b>{{ subscription.trial_days }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-12">
        <p><b>Coupon Id: </b>{{ subscription.coupon_id }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-12">
        <p><b>Initial cost: </b>{{ subscription.subscription_cost }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-12">
        <p><b>Account Credits: </b>{{ subscription.credits }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-12">
        <p><b>Content Code: </b>{{ subscription.content_code }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-12">
        <p><b>Campaign Name: </b>{{ subscription.campaign_name }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-12">
        <p><b>Campaign Type: </b>{{ subscription.campaign_type }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-12">
        <p><b>Billing frequency: </b>{{ subscription.billing_frequency }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-12">
        <p>
          <b>Additional user cost: </b>{{ subscription.additional_user_cost }}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-12">
        <p>
          <b>Additional user plan: </b>{{ subscription.additional_user_plan }}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-12">
        <p><b>Contact group name: </b>{{ subscription.user_contact_group }}</p>
      </div>
    </div>
  </div>
  <app-button
    class="ShowSubscription-button"
    [size]="backBButtonProperties.size"
    [color]="backBButtonProperties.color"
    [route]="backBButtonProperties.route"
    [text]="backBButtonProperties.text"></app-button>
</div>
